module.exports = __webpack_public_path__ + "img/GU.2a95d57a.svg";